import { render } from "@testing-library/react";

const defaultRender = (value) => (value ? value : '--');
const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render:defaultRender,
        sorter:true
    },
    // {
    //     title: 'Email',
    //     dataIndex: 'email',
    //     sorter:true
    // },
    {
        title: 'Mobile No.',
        dataIndex: 'phoneNo',
        sorter:true
    },
    {
        title: 'Wallet Account Number',
        dataIndex: 'walletAccountNo',
        sorter:true
    },
    {
        title:'Balance',
        dataIndex: 'balance',
        sorter:true
    },
    {
        title:'Requested Amount',
        dataIndex: 'requestedAmount',
        sorter:true
    },
    {
        title:'Fee (%)',
        dataIndex: 'charge',
    },
    {
        title:'Amount to Pay',
        dataIndex: 'netAmount',
    },
    {
        title: 'Deposit Type',
        dataIndex: 'depositType',
        sorter:true
    },
    {
        title:'Comment',
        dataIndex: 'comment',
        sorter:true
    },
    // {
    //     title:'Document',
    //     dataIndex: 'documentUrl',
    // },
    {
        title:'Request Date',
        dataIndex: 'requestDate',
        sorter:true
    },
    {
        title:'Action By',
        dataIndex: 'actionBy',
        render: defaultRender,
    },
    {
        title:'Action Date',
        dataIndex: 'actionDate',
        sorter:true
    },
    {
        title:'Status',
        dataIndex: 'status',
        sorter:true
    },
    {
        title:'Actions',
        dataIndex: 'actions',
    },
    
   
];


export default columns;